import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Sparkles, AlertCircle } from "lucide-react";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (username.length < 3) return setError("Username must be at least 3 characters");
        if (password.length < 6) return setError("Password must be at least 6 characters");
        setSubmitting(true);
        const res = await register(username, password);
        setSubmitting(false);
        if (res.ok) navigate("/");
        else setError(res.error);
    };

    return (
        <div className="max-w-md mx-auto px-4 sm:px-6 py-12 lg:py-20">
            <div data-testid="register-card" className="brutal-card p-8 lg:p-10 bg-white">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-vibrantpink border-[3px] border-ink rounded-2xl shadow-brutal mb-6">
                    <Sparkles className="w-7 h-7 text-white" strokeWidth={2.5} />
                </div>
                <h1 className="font-heading font-black text-4xl tracking-tighter text-ink mb-2">
                    Join the party
                </h1>
                <p className="font-body text-ink/70 mb-8">Just a username and password. No email needed.</p>

                <form onSubmit={onSubmit} className="space-y-4" data-testid="register-form">
                    <div>
                        <label className="font-heading font-bold text-xs uppercase tracking-widest text-ink mb-2 block">Username</label>
                        <input
                            data-testid="register-username-input"
                            type="text"
                            className="brutal-input"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="pickaname"
                            autoComplete="username"
                            minLength={3}
                            maxLength={24}
                            required
                        />
                    </div>
                    <div>
                        <label className="font-heading font-bold text-xs uppercase tracking-widest text-ink mb-2 block">Password</label>
                        <input
                            data-testid="register-password-input"
                            type="password"
                            className="brutal-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="6+ chars"
                            autoComplete="new-password"
                            minLength={6}
                            required
                        />
                    </div>
                    {error && (
                        <div data-testid="register-error" className="flex items-start gap-2 bg-vibrantpink/15 border-[3px] border-vibrantpink text-ink rounded-xl p-3">
                            <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5 text-vibrantpink" strokeWidth={2.5} />
                            <span className="font-body font-semibold text-sm">{error}</span>
                        </div>
                    )}
                    <button
                        type="submit"
                        data-testid="register-submit-button"
                        disabled={submitting}
                        className="brutal-btn-primary w-full"
                    >
                        {submitting ? "Creating..." : "Create account"}
                    </button>
                </form>

                <p className="text-center mt-6 font-body text-sm text-ink/70">
                    Already have an account?{" "}
                    <Link to="/login" data-testid="register-to-login-link" className="font-heading font-bold underline decoration-vibrantorange decoration-[3px] underline-offset-4 text-ink">
                        Log in
                    </Link>
                </p>
            </div>
        </div>
    );
}
